import React, { useEffect, useState } from 'react'
import { NavBar } from '../../../components/NavBar/NavBar'
import {
  PageWrapper,
  Flex,
  GridItem,
  GridWrapper,
  Separator,
  ItemsGrid,
  H1WithBack,
} from '../../../styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import {
  clearInventoryCategory,
  deleteInventoryCategory,
  getSingleInventoryCategory,

} from 'features/inventory/invSettingsCategoriesSlice'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { convertToInvCategoriesModalData } from './InventoryCategories'
import { TitleText } from 'styling/Typography'
import { InventoryCategoryModal } from './InventoryCategoryModal'
import { setConfirmModal } from 'features/global/globalSlice'
import { ModalTypes } from 'types/global.interface'
import RemoveCircle from 'assets/icons/RemoveCircle'

export const InventoryCategory = () => {
  const { singleInventoryCategory } = useSelector(
    (state: RootState) => state.inventoryCategories,
  )
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const { id } = useParams()
  const [modal, setModal] = useState({ open: false, value: null, sub: false })

  useEffect(() => {
    dispatch(getSingleInventoryCategory(id))
    return () => {
      dispatch(clearInventoryCategory())
    }
  }, [])



  const removeCategory = (catId: number) => {
    dispatch(
      setConfirmModal({
        isOpen: true,
        onSave: async () => {
          await dispatch(deleteInventoryCategory({ id: catId, reloadId: Number(id) }))
        },
        setParams: {
          type: ModalTypes.Delete
        },
        word: 'delete category',
      }),
    )
  }

  return (
    <>
      <NavBar />
      <PageWrapper>
        <Flex between>
          <H1WithBack arrow title={singleInventoryCategory?.name} />
          <Flex gap='1rem' center >
            <Button variant='secondary' onClick={() => setModal({ open: true, value: convertToInvCategoriesModalData(singleInventoryCategory), sub: false })}>
              Edit
            </Button>
            <Button variant='primary' onClick={() => setModal({ open: true, value: null, sub: true })}>
              Add Subcategory
            </Button>
          </Flex>
        </Flex>
        <Separator />
        <TitleText weight='bold' >Subcategories:</TitleText>
        <GridWrapper>
          <ItemsGrid columns={3}>
            {singleInventoryCategory?.subcategories?.length ? (
              singleInventoryCategory?.subcategories?.map((item) => {
                const { name, id } = item
                return (
                  <GridItem onClick={() => navigate('subcategory/' + id)} key={id}>
                    {name}
                    <Flex between center onClick={(e) => {
                      e.stopPropagation()
                      removeCategory(id)
                    }}>
                      <RemoveCircle />
                    </Flex>
                  </GridItem>
                )
              })
            ) : (
              <NoItems title='subcategories' />
            )}
          </ItemsGrid>
        </GridWrapper>
        {modal.open && (
          <InventoryCategoryModal value={modal.value} subcategory={modal.sub} parentId={Number(id)} closeModal={() => setModal({ open: false, value: null, sub: false })} />
        )}
      </PageWrapper>
      {/* {Math.ceil(operations.totalCount / 30) > 1 && (
        <Pagination
          setPage={(selected) => navigate('?page=' + selected + '&limit=30')}
          pageCount={Math.ceil(operations.totalCount / 30)}
          forcePage={page - 1}
        />
      )} */}
    </>
  )
}
